module.exports = __webpack_public_path__ + "img/email.cc01f70f.png";